import React from 'react';
import { RouteFormatter } from '../../routes';
import { SPOT_SRC_MEMBERSHIP } from '../../consts/spot-src';
import { showPrice, showPriceCredits } from '../../helpers/price';
import SvgKeyboardRight from 'src/assets/svg/SvgKeyboardRight.svg';
import SvgSubscription from 'src/assets/svg/SvgSubscription.svg';
import SvgSeoOk from 'src/assets/svg/SvgSeoOk.svg';
import useHistory from '../../services/hooks/useHistory';

const MEMBER_DISCOUNT_TEXT = 'Members get discounts on all bookings at all spots by buying monthly credits!';

const RenderPrice = ({ spot, SSR, hasSniffpass, publicPark, setIsBlurTest }) => {
    const history = SSR ? null : useHistory();

    const handleSniffpass = async () => {
        if (SSR) {
            setIsBlurTest(true);
        } else {
            history.push({
                pathname: RouteFormatter.subscriptionsNew(),
                state: { src: SPOT_SRC_MEMBERSHIP.WEB_DETAIL_PRICING },
            });
        }
    };

    return (
        <div className="price px-2 px-md-0">
            <div className="snif-m1 snif-semibold mt-3 mb-2">Pricing</div>
            <span className="price-box snif-p">
                {publicPark ? (
                    <>{!spot.price || spot.price === 0 ? 'No fee info' : showPrice(spot.price)}</>
                ) : (
                    <>
                        <span className="snif-m2 snif-bold">{showPriceCredits(spot.price)} </span>
                        per dog per hour
                    </>
                )}
            </span>
            {!publicPark && (
                <>
                    <p className="snif-p d-flex align-items-center mt-4">
                        <SvgSeoOk className="ok-icon" />
                        <span>50% off all dogs after the 1st dog</span>
                    </p>
                    {spot.minimumLength < 1 && (
                        <p className="snif-p d-flex align-items-center mt-3">
                            <SvgSeoOk className="ok-icon" />
                            <span>25% off hourly price for 30 min visit</span>
                        </p>
                    )}
                    <div className="snif-p d-flex mt-3">
                        <SvgSubscription className="ok-icon" />
                        <div style={{ width: 'calc(100% - 40px)' }}>
                            <p>
                                {spot.offerSniffpass ? (
                                    <>
                                        {MEMBER_DISCOUNT_TEXT}
                                        <br />
                                        This spot offers additional discounts.
                                    </>
                                ) : (
                                    MEMBER_DISCOUNT_TEXT
                                )}
                            </p>
                            {!hasSniffpass && (
                                <span className="d-inline-block c-pointer mt-1" onClick={handleSniffpass}>
                                    <span className="snif-medium text-underline pt-05">Learn more</span>
                                    <SvgKeyboardRight className="ms-1" />
                                </span>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="my-4">
                <hr />
            </div>
        </div>
    );
};
export default RenderPrice;
